import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { adminGuard } from './core/guards/role.guard';

export const routes: Routes = [
  {
    path: 'callback',
    loadChildren: () =>
      import('./features/auth/callback/callback.module').then(
        (m) => m.CallbackModule
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'analytics',
    loadComponent: () =>
      import('./features/analytics/analytics.component').then(
        (m) => m.AnalyticsComponent
      ),
    canActivate: [adminGuard],
  },
  {
    path: 'payment-success',
    loadComponent: () =>
      import(
        './features/payment/payment-success/payment-success.component'
      ).then((m) => m.PaymentSuccessComponent),
  },
  {
    path: 'payment-success-redirect',
    loadComponent: () =>
      import(
        './features/payment/payment-success/payment-success.component'
      ).then((m) => m.PaymentSuccessComponent),
  },
  {
    path: 'payment-cancel',
    loadComponent: () =>
      import('./features/payment/payment-cancel/payment-cancel.component').then(
        (m) => m.PaymentCancelComponent
      ),
  },
  {
    path: 'support',
    loadComponent: () =>
      import('./features/support/support.component').then(
        (m) => m.SupportComponent
      ),
  },
  {
    path: 'privacy',
    loadComponent: () =>
      import('./features/privacy/privacy.component').then(
        (m) => m.PrivacyComponent
      ),
  },
  {
    path: 'home',
    redirectTo: '/',
    pathMatch: 'full',
  },
  {
    path: 'translation',
    redirectTo: '/',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () =>
      import('./app.component').then((m) => m.AppComponent),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
